const BOOT_THEME_STYLE_ID = 'cobranding-boot-theme';

type BootTheme = { light: string; dark: string };

/**
 * Cobranding experiences that theme the document background before React
 * renders, to avoid a white (or host-window) flash during the loading sequence.
 *
 * Keyed by the `application` URL param (`coreApplication--experience`) because
 * that is the only cobranding signal available synchronously at bootstrap — the
 * redux cobranding state is only resolved after the page-state fetch. Opt an
 * experience in by adding a row here.
 */
const BOOT_THEMES: Readonly<Record<string, BootTheme>> = {
  'dia--dia': { light: '#feffff', dark: '#000' },
  'dia--windows': { light: '#f3f3f3', dark: '#202020' },
};

/**
 * Applies the boot theme for the current cobranding experience (if any) before
 * the first paint. Generic and idempotent; a no-op for experiences without a
 * registered theme.
 */
export function applyCobrandingBootTheme(): void {
  if (typeof document === 'undefined') return;

  let application: string | null = null;
  try {
    application = new URLSearchParams(window.location.search).get('application');
  } catch {
    return;
  }

  const theme = application ? BOOT_THEMES[application] : undefined;
  if (!theme || document.getElementById(BOOT_THEME_STYLE_ID)) return;

  document.documentElement.style.colorScheme = 'light dark';

  const style = document.createElement('style');
  style.id = BOOT_THEME_STYLE_ID;
  style.textContent = [
    `:root { --cobranding-loading-overlay-bg: ${theme.light}; }`,
    `@media (prefers-color-scheme: dark) { :root { --cobranding-loading-overlay-bg: ${theme.dark}; } }`,
    'html, body { background: var(--cobranding-loading-overlay-bg) !important; }',
  ].join('\n');
  document.head.appendChild(style);
}
